import { Card } from "antd";
import classnames from "classnames";
import styles from "./MetaDataCard.module.scss";

const MetaDataCard = ({ icon, title, text, background, children }) => {
  const cls = classnames({
    [styles.grey]: background === "grey",
  });

  return (
    <Card variant="borderless" classNames={styles} className={cls}>
      <div className={styles.header}>
        {icon && icon}
        {title && <p className={styles.title}>{title}</p>}
      </div>

      {text && <p className={styles.text}>{text}</p>}
      {children && children}
    </Card>
  );
};

export default MetaDataCard;
